import React from "react";
import {CyClass} from "../../../../common/cy-classes";
import {GeoModalWrapperBox} from "../boxes/geo-modal-wrapper.box";
import {DialogHighlightedTextBox, DialogTextBox} from "../../modal-dialog/boxes/text/dialog-text.box";
import {
    IModalDialogButtonsComponentProps,
    ModalDialogActionsComponent
} from "../../modal-dialog/modal-dialog-actions.component";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";

interface IGeoLocationGameRestrictionPopupComponentProps {
    dialogHandler: IModalDialogHandler;
    buttons: IModalDialogButtonsComponentProps;
    headerText1?: string;
    headerText2?: string;
}

export class GeoLocationGameRestrictionPopupComponent extends React.PureComponent<IGeoLocationGameRestrictionPopupComponentProps> {
    private _closeDialogBox = () => {
        this.props.dialogHandler && this.props.dialogHandler.close();
    };

    render() {
        let { primaryAction, secondaryAction } = this.props.buttons;

        const primaryActionOnClick = primaryAction.onClick;
        primaryAction = {
            ...primaryAction,
            onClick: () => {
                primaryActionOnClick();
                this._closeDialogBox();
            },
            className: CyClass('cy-game-restriction-geo-location-primary-button') + ' ' + primaryAction.className
        }

        if (secondaryAction) {
            const secondaryActionOnClick = secondaryAction.onClick;
            secondaryAction = {
                ...secondaryAction,
                onClick: () => {
                    secondaryActionOnClick();
                    this._closeDialogBox();
                },
                className: CyClass('cy-game-restriction-geo-location-secondary-button') + ' ' + secondaryAction.className
            }
        }

        const {headerText1,headerText2} = this.props;

        return (
            <GeoModalWrapperBox>
                {headerText1 && <DialogHighlightedTextBox>{headerText1}</DialogHighlightedTextBox>}
                {headerText2 && <DialogTextBox>{headerText2}</DialogTextBox>}
                <ModalDialogActionsComponent
                    primaryAction={primaryAction}
                    secondaryAction={secondaryAction}
                    buttonsOnSeparateLines
                    className={CyClass("cy-modal-dialog-buttons-area")}
                />
            </GeoModalWrapperBox>
        );
    }
}